import React from 'react';
import { LaunchBanner } from '../components/landing/LaunchBanner';
import { HeroSection } from '../components/landing/HeroSection';
import { PremiumShowcaseSection } from '../components/landing/PremiumShowcaseSection';
import { ProblemSection } from '../components/landing/ProblemSection';
import { HowItWorksSection } from '../components/landing/HowItWorksSection';
import { TestimonialsSection } from '../components/landing/TestimonialsSection';
import { ExpertSection } from '../components/landing/ExpertSection';
import { PricingSection } from '../components/landing/PricingSection';
import { GuaranteeSection } from '../components/landing/GuaranteeSection';
import { FAQSection } from '../components/landing/FAQSection';
import { FinalCTASection } from '../components/landing/FinalCTASection';
import { Footer } from '../components/landing/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-brand-cream font-sans text-slate-900 selection:bg-brand-terracotta/20" data-id="element-694">
      <LaunchBanner data-id="element-695" />
      <main data-id="element-696">
        <HeroSection data-id="element-697" />
        <PremiumShowcaseSection data-id="element-698" />
        <ProblemSection data-id="element-699" />
        <HowItWorksSection data-id="element-700" />
        <TestimonialsSection data-id="element-701" />
        <ExpertSection data-id="element-702" />
        <PricingSection data-id="element-703" />
        <GuaranteeSection data-id="element-704" />
        <FAQSection data-id="element-705" />
        <FinalCTASection data-id="element-706" />
      </main>
      <Footer data-id="element-707" />
    </div>;
}